<div class="scheduleContactModal">
    <span class="closeBtn" (click)="close()">
        <mat-icon fontSet="material-icons-round">close</mat-icon>
    </span>
    <div class="title">
        <h1>{{ 'scheduleContactDialog.title' | translate }}</h1>
    </div>

    <div [formGroup]="contactForm" class="input-data">
        <input formControlName="name" class="input" type="text" maxlength="100" [placeholder]="'scheduleContactDialog.name' | translate">

        <input formControlName="email" class="input" type="text" maxlength="100" [placeholder]="'scheduleContactDialog.email' | translate">
        <div class="not-match absolute" *ngIf="(contactForm?.controls?.email?.invalid && contactForm?.controls?.email?.touched)">
            {{ 'simpleContactModal.hint.email' | translate }}
        </div>
    </div>

    <div class="inputGroup">
        <input [(ngModel)]="contact" mask="(00) 00000-0000" (keypress)="onKeyPressEvent($event)" type="text" class="input" [placeholder]="'scheduleContactDialog.insertPhone' | translate">
        <div class="select-wrapper">
            <mat-select [(ngModel)]="period" placeholder="{{'scheduleContactDialog.choosePeriod' | translate}}" class="select">
                <mat-option [value]="'morning'" class="placeholder" selected>{{ 'scheduleContactDialog.morning' | translate }}</mat-option>
                <mat-option [value]="'afternoon'" class="placeholder">{{ 'scheduleContactDialog.afternoon' | translate }}</mat-option>
                <mat-option [value]="'night'" class="placeholder">{{ 'scheduleContactDialog.night' | translate}}</mat-option>
            </mat-select>
        </div>
    </div>

    <textarea rows="5" [(ngModel)]="observation" [placeholder]="'scheduleContactDialog.observation' | translate" maxlength="500"></textarea>
    <span class="counter">{{ observation.length }} / 500</span>

    <div class="actions">
        <button (click)="close()" mat-flat-button class="btn outlined">{{ 'button.cancel' | translate }}</button>
        <button [disabled]="checkToSend()" (click)="sendContact()" mat-flat-button class="btn default">{{ 'scheduleContactDialog.schedule' | translate }}</button>
    </div>
    <mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>
